import { Button, Textarea } from '@cian/ui-kit';
import { IconCommunicationSend16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatStartMessageForm.css';
import { useTypewriter } from './utils/useTypewriter';

export interface IChatStartMessageFormProps {
  onClick(): void;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isDisabled: boolean;
  inputRef?: React.Ref<HTMLTextAreaElement>;
}

export function ChatStartMessageForm({ onClick, onChange, inputRef }: IChatStartMessageFormProps) {
  const placeholderStrings = ['К вам можно с котом?', 'Ещё сдаёте?', 'Соседи нормальные?', 'Куда выходят окна?'];
  const animatedPlaceholder = useTypewriter(placeholderStrings, 50);

  return (
    <div className={styles['form']}>
      <div className={styles['textarea']}>
        <Textarea
          maxLength={800}
          placeholder={animatedPlaceholder}
          onChange={value => onChange(value)}
          inputRef={inputRef}
        />
      </div>
      <div className={styles['button']}>
        <Button
          theme="fill_primary"
          size="M"
          beforeIcon={<IconCommunicationSend16 color="icon-inverted-default" />}
          onClick={onClick}
        />
      </div>
    </div>
  );
}
